<div class="modal-header py-2">
    <h2 class="mb-0">Free trial period</h2>
    <span class="icon icon-cross ml-auto py-1 px-2" (click)="close()"></span>
</div>
<div class="modal-body">
    <p>You'll activate a 14 day free trial period. You'll have full access to all Premium plan features, except for the
        message limit, which will be limited to {{freeTrialMessagesLimit | number}} messages.</p>
</div>
<div class="modal-footer">
    <button
        class="btn btn-primary mr-2"
        angularticsCategory="account"
        angulartics2On="click"
        angularticsAction="Confirm Free Trial period"
        type="submit"
        [disabled]="inProgress"
        (click)="confirm()"
    >Confirm</button>
    <button type="button" class="btn btn-danger" [disabled]="inProgress" (click)="close()">Cancel</button>
</div>
